import { Route, Routes } from "react-router-dom";
import "./App.css";
import { Navbar } from "./components/Navbar";
import { About, Home, Contact } from "./components/pages";

function App() {
  return (
    <html>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/meist" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </div>
    </html>
  );
}

export default App;